export default __webpack_public_path__ + "static/media/tinnauerP.d8cbdbeb.jpg";